export function normalizeRole(role?: string | null): string {
  return String(role || "").trim().toUpperCase();
}

export function isManagerOrAdmin(role?: string | null): boolean {
  const r = normalizeRole(role);
  return r === "ADMIN" || r === "MANAGER";
}

export function canAccessPosMonitor(role?: string | null): boolean {
  const r = normalizeRole(role);
  return r === "ADMIN" || r === "MANAGER" || r === "OPERATOR";
}

export function canAccessEasyRetailReports(role?: string | null): boolean {
  return canAccessPosMonitor(role);
}
